import PaginatedSelect from '../form/PaginatedSelect';
import { loadStores } from '../../services/api/StoreService';
import { BaseOptionType, DefaultOptionType } from 'rc-select/lib/Select';
import { SelectProps } from 'antd';
import React from 'react';

type Props<ValueType, OptionType extends BaseOptionType = DefaultOptionType> = SelectProps<
  ValueType,
  OptionType
>;

export default function StoreSelector(props: Props<string | string[]>) {
  const loadPage = (page: number, query: string) => loadStores({ page, query });

  return <PaginatedSelect loadPage={loadPage} {...props} />;
}
